import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import { DeliverRequest, InvalidateCacheAndCreateNew } from "./requests";

var axios = require('axios');

global.isAuthenticated = typeof window !== 'undefined' && window.localStorage.getItem("__aSID") !== null;
global.authenticationConnectors = [];
global.accessToken = typeof window !== 'undefined' && window.localStorage.getItem("__aSID") !== null ? window.localStorage.getItem("__aSID") : null;
global.previousLogin = typeof window !== 'undefined' && window.localStorage.getItem("__aPrL") !== null ? JSON.parse(window.localStorage.getItem("__aPrL")) : null;
global.fingerPrint = null;
global.deviceId = null;
global.isInApp = false;
global.loginIdentifier = null;
export function connectStateToAuth(_x) {
  return _connectStateToAuth.apply(this, arguments);
}

function _connectStateToAuth() {
  _connectStateToAuth = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(setState) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            global.authenticationConnectors.push({
              connect: setState
            });
            setState(isAuthenticated);

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _connectStateToAuth.apply(this, arguments);
}

export function runAuthConnectors() {
  return _runAuthConnectors.apply(this, arguments);
}

function _runAuthConnectors() {
  _runAuthConnectors = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var connection;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.t0 = _regeneratorRuntime.keys(global.authenticationConnectors);

          case 1:
            if ((_context2.t1 = _context2.t0()).done) {
              _context2.next = 8;
              break;
            }

            connection = _context2.t1.value;

            if (!(connection.connect && typeof connection.connect === "function")) {
              _context2.next = 6;
              break;
            }

            _context2.next = 6;
            return connection.connect(true);

          case 6:
            _context2.next = 1;
            break;

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _runAuthConnectors.apply(this, arguments);
}

export function logout() {
  return _logout.apply(this, arguments);
}

function _logout() {
  _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var x, y;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            x = getPreviousLoginMetadata();

            if (typeof window !== "undefined") {
              window.localStorage.clear();
            }

            global.isAuthenticated = false;
            global.accessToken = null;
            _context3.next = 6;
            return DeliverRequest({}, "logout", false, 0.001, false);

          case 6:
            y = _context3.sent;
            InvalidateCacheAndCreateNew();

            if (typeof window !== "undefined") {
              window.localStorage.setItem("__aPrL", JSON.stringify(x));
            }

            _context3.next = 11;
            return runAuthConnectors();

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _logout.apply(this, arguments);
}

export function getPreviousLoginMetadata() {
  return _getPreviousLoginMetadata.apply(this, arguments);
}

function _getPreviousLoginMetadata() {
  _getPreviousLoginMetadata = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!(typeof window !== "undefined")) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt("return", JSON.parse(window.localStorage.getItem("__aPrL")));

          case 2:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getPreviousLoginMetadata.apply(this, arguments);
}

export function getFingerPrint() {
  return _getFingerPrint.apply(this, arguments);
}

function _getFingerPrint() {
  _getFingerPrint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    var FingerprintJS, fingerPrinter, theFingerPrint;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!(typeof window !== "undefined")) {
              _context5.next = 17;
              break;
            }

            if (global.fingerPrint) {
              _context5.next = 16;
              break;
            }

            _context5.next = 4;
            return import('@fingerprintjs/fingerprintjs');

          case 4:
            FingerprintJS = _context5.sent;
            _context5.next = 7;
            return FingerprintJS.load();

          case 7:
            fingerPrinter = _context5.sent;
            _context5.next = 10;
            return fingerPrinter.get();

          case 10:
            theFingerPrint = _context5.sent;
            global.fingerPrint = theFingerPrint.components;
            global.deviceId = theFingerPrint.visitorId;
            return _context5.abrupt("return", global.fingerPrint);

          case 16:
            return _context5.abrupt("return", global.fingerPrint);

          case 17:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _getFingerPrint.apply(this, arguments);
}

export function getDeviceId() {
  return _getDeviceId.apply(this, arguments);
}

function _getDeviceId() {
  _getDeviceId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (!(!global.fingerPrint || !global.deviceId)) {
              _context6.next = 3;
              break;
            }

            _context6.next = 3;
            return getFingerPrint();

          case 3:
            return _context6.abrupt("return", global.deviceId);

          case 4:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _getDeviceId.apply(this, arguments);
}

export function getAccessToken() {
  return _getAccessToken.apply(this, arguments);
}

function _getAccessToken() {
  _getAccessToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            if (!(typeof window !== "undefined")) {
              _context7.next = 2;
              break;
            }

            return _context7.abrupt("return", window.localStorage.getItem("__aSID"));

          case 2:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _getAccessToken.apply(this, arguments);
}

export function setAccessToken(_x2) {
  return _setAccessToken.apply(this, arguments);
}

function _setAccessToken() {
  _setAccessToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(token) {
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (typeof window !== "undefined") {
              window.localStorage.setItem("__aSID", token);
            }

            global.accessToken = token;
            global.isAuthenticated = true;

          case 3:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _setAccessToken.apply(this, arguments);
}

export function hasAccessToken() {
  return _hasAccessToken.apply(this, arguments);
}

function _hasAccessToken() {
  _hasAccessToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return getAccessToken();

          case 2:
            _context9.t0 = _context9.sent;
            return _context9.abrupt("return", _context9.t0 != null);

          case 4:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _hasAccessToken.apply(this, arguments);
}

export function login(_x3, _x4) {
  return _login.apply(this, arguments);
}

function _login() {
  _login = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(endpoint, data) {
    var token, toSend;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            if (typeof window !== 'undefined' && window.localStorage.getItem("__aSID") !== null) {
              token = window.localStorage.getItem("__aSID");
            } else {
              token = null;
            }

            _context10.t0 = data;
            _context10.t1 = endpoint;
            _context10.next = 5;
            return getFingerPrint();

          case 5:
            _context10.t2 = _context10.sent;
            _context10.next = 8;
            return getDeviceId();

          case 8:
            _context10.t3 = _context10.sent;
            _context10.t4 = token;
            toSend = {
              data: _context10.t0,
              endpoint: _context10.t1,
              deviceFingerprint: _context10.t2,
              deviceId: _context10.t3,
              token: _context10.t4
            };
            InvalidateCacheAndCreateNew();
            _context10.prev = 12;
            return _context10.abrupt("return", axios.post(global.baseUrl + "auth/", toSend).then(function (result) {
              if (result.status === 200) {
                if (typeof result.data === "string") {
                  setAccessToken(result.data);

                  if (loginIdentifier) {
                    if (typeof window !== "undefined") {
                      window.localStorage.setItem("__aPrL", JSON.stringify(loginIdentifier));
                    }

                    global.loginIdentifier = loginIdentifier;
                  }

                  InvalidateCacheAndCreateNew();
                  global.viewConnectors.forEach(function (connection) {
                    connection.connect();
                  });
                  global.searchConnectors.forEach(function (connection) {
                    connection.connect();
                  });
                  runAuthConnectors();
                }

                return {
                  success: true,
                  result: ""
                };
              }
            }).catch(function (result) {
              global.authenticationConnectors.forEach(function (connection) {
                connection.connect(false);
              });

              if (result.response && result.response.data && result.response.data.errorMessage) {
                return {
                  success: false,
                  result: result.response.data.errorMessage
                };
              } else if (result.response && result.response.statusText) {
                return {
                  success: false,
                  result: result.response.statusText
                };
              } else {
                return {
                  success: false,
                  result: "Your internet connection may be offline. Check it and refresh this page."
                };
              }
            }));

          case 16:
            _context10.prev = 16;
            _context10.t5 = _context10["catch"](12);
            global.authenticationConnectors.forEach(function (connection) {
              connection.connect(false);
            });
            return _context10.abrupt("return", {
              success: false,
              result: _context10.t5
            });

          case 20:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[12, 16]]);
  }));
  return _login.apply(this, arguments);
}